import { render } from "./RichTextBlock.vue?vue&type=template&id=45cf906b"
import script from "./RichTextBlock.vue?vue&type=script&lang=js"
export * from "./RichTextBlock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__